// extracted by mini-css-extract-plugin
module.exports = {"float":"WhatsAppFloat_float__BTQin"};